import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=84d55a32&scoped=true&"
import script from "./Features.vue?vue&type=script&lang=ts&"
export * from "./Features.vue?vue&type=script&lang=ts&"
import style0 from "./Features.vue?vue&type=style&index=0&id=84d55a32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d55a32",
  null
  
)

export default component.exports